module.exports = __webpack_public_path__ + "media/customizations/regencyathollysprings/logo-dc387aa1a99533f58d0398fd35cf8462.png";